import axios from 'axios';

export async function getHittingStats(year, timeframe = null) {
  const url = `https://bdfed.stitch.mlbinfra.com/bdfed/stats/team?stitch_env=prod&sportId=1&gameType=R&group=hitting&order=desc&sortStat=onBasePlusSlugging&stats=season&season=${year}&limit=30&offset=0${timeframe ? '&daysBack=' : ''}${timeframe || ''}`;
  const config = {
    url: url,
    method: 'get',
    headers: {
      "accept": "*/*",
      "accept-language": "en-US,en;q=0.9"
    }
  }

  try {
    console.log('Attempting to connect to stat api for hitting')
    const response = await axios(config);
    return response.data.stats;
  } catch (error) {
    return error;
  }

}